/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        itemFontColor: '#4b286d',
        itemUnderline: 'underline'
      }
    },
    {
      if: { focus: true },
      tokens: {
        backgroundColor: '#e3e6e8',
        itemFontColor: '#414547',
        itemUnderline: 'underline'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#b2b9bf',
        dividerColor: '#b2b9bf',
        itemFontColor: '#676e73',
        itemIconColor: '#676e73',
        itemUnderline: 'underline'
      }
    }
  ],
  tokens: {
    backgroundColor: null,
    dividerColor: '#676e73',
    dividerSize: 1,
    iconMarginTop: 0,
    interItemMargin: 0,
    interItemMarginWithDivider: 0,
    itemBulletColor: '#4b286d',
    itemBulletContainerAlign: 'center',
    itemBulletContainerWidth: 16,
    itemBulletHeight: 4,
    itemBulletWidth: 4,
    itemFontColor: '#676e73',
    itemFontName: 'HNforTELUSSA',
    itemFontSize: 16,
    itemFontWeight: '700',
    itemIconColor: '#4b286d',
    itemIconSize: 24,
    itemLineHeight: 1.5,
    itemUnderline: 'none',
    listGutter: 16,
    paddingBottom: 12,
    paddingLeft: null,
    paddingRight: null,
    paddingTop: 12
  }
}
export default theme
